import { LocalizedString } from '@cue/api';
import { QrCodeData, ResourcePropertyInfo, TagData } from '@cue/data';

export enum VirtualKeyboardButtonSize {
  Default,
  Small,
  Large,
  ExtraLarge,
}
export interface VirtualKeyboardButton {
  buttonSize: VirtualKeyboardButtonSize;
  defaultValue: string;
  ctrlValue?: string;
  shiftValue?: string;
  isShiftFn?: boolean;
  isCapsLockFn?: boolean;
  isSpaceFn?: boolean;
  isDeleteFn?: boolean;
  isCtrlFn?: boolean;
  isEnterFn?: boolean;
  class?: string;
  isCloseFn?: boolean;
}

export interface VirtualKeyboardLayout {
  firstRow: VirtualKeyboardButton[];
  secondRow: VirtualKeyboardButton[];
  thirdRow: VirtualKeyboardButton[];
  fourthRow: VirtualKeyboardButton[];
  fifthRow: VirtualKeyboardButton[];
}
